/**
 * Nested document-tag columns cannot be sorted: they hold one-to-many chips,
 * not a single API field. Bills use RECEIPTS (plural), matching PURCHASE
 * ORDERS. Receipt and receipt-adjustment RECEIPT NO is the document number
 * and stays sortable.
 *
 * @param {string} header Uppercase column header.
 * @returns {boolean}
 */
export const isNestedTagColumnUnsortable = header =>
  header === "PURCHASE ORDERS" ||
  header === "TRANSFER ORDERS" ||
  header === "RECEIPTS" ||
  header === "SHIPMENTS";
